import { ObjectWithNonEmptyValues } from './allValuesNonEmty.type'

export const allValuesNonEmpty = (obj: ObjectWithNonEmptyValues): boolean => {
	return Object.keys(obj).every(key => !!obj[key])
}
